import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { ConfirmDailogueComponent } from "src/app/shared/components/dailogue/confirm-dailogue.component";
import { Api } from "src/app/shared/constants/api";
import { APP_ROUTES } from "src/app/shared/constants/approutes";
import { Message } from "src/app/shared/constants/message";
import { PermissionKey } from "src/app/shared/constants/permissionCode";
import { IPermissionWithShow } from "src/app/shared/interface";
import { DataService } from "src/app/shared/services/data.service";
import { PermissionService } from "src/app/shared/services/permissions.service";
import { UtilityService } from "src/app/shared/services/utility.service";
import * as _ from 'underscore';

@Component({
    selector: 'app-gst',
    templateUrl: './gst-form.component.html',
    styleUrls: ['./gst-form.component.less'],
    standalone: false
})
export class GstFormComponent implements OnInit {
  constructor(private formBuilder:FormBuilder, private activatedRoute:ActivatedRoute,
              private service:DataService,private logger:NGXLogger,private utilityService:UtilityService,
              private router:Router,private dailog:MatDialog, private permissionService:PermissionService){ }

  gstForm:FormGroup;  
  gstTypes:any; 
  isEditedData:boolean=false;   
  editPermission:boolean=false;
  addPermission:boolean=false;
  viewLog = this.formBuilder.control(false);

  ngOnInit(){
    this.viewLog.setValue(false);
    this.getAllPermissions();
    this.getGstTypes();
    this.initializeForm();
    this.fetchParam();
  }

  private fetchParam(){
    this.activatedRoute.params.subscribe(
      (param:Params) => {
        if(+param['id']){
          this.id.setValue(+param['id']);
          this.getGstById();
        }
    });
  }

  initializeForm(){
    this.gstForm=this.formBuilder.group({
      id:[null],
      code:[null,[Validators.required]],
      name:[null,[Validators.required]],
      description:[],
      type:[null,[Validators.required]]
    })
  }

  openDailog(message?:string)
  {
    const dailogRef=this.dailog.open(ConfirmDailogueComponent,{
        data:message,
        maxWidth:"300px",
        maxHeight:"150px"
      });

    dailogRef.afterClosed().subscribe(dailogResult => {
        if(dailogResult===false){
          return;
        }
        else {
          if(!this.isEditedData) {
            this.router.navigate([APP_ROUTES.GST_LIST]);
          }
          else {
            this.saveGst();
          }
        }
    })
  }

  save(){
    this.gstForm.markAllAsTouched();
    if(this.gstForm.valid){
       this.isEditedData=true;
       if(this.id.value && this.gstForm.dirty){
           this.openDailog(Message.SAVE_OPEN_DAILOG_IN_EDIT);
       }
       else {
         this.openDailog(Message.SAVE_OPEN_DAILOG);
       } 
    }
 }

  private saveGst(){
    let method = (this.id.value) ? 'put' : 'post';
    let message=(this.id.value)?'updated':'saved';
    this.service[method](Api.GST, this.gstForm.value).subscribe(res => {
      this.utilityService.notifier(`Gst Details ${message} successfully`, 'success');
      this.router.navigate([APP_ROUTES.GST_LIST]);
    });
  }

  cancel(){
    if(this.gstForm.dirty){
      this.isEditedData=false;
      this.id.value?this.openDailog(Message.CANCEL_OPEN_DAILOG_IN_EDIT):this.openDailog(Message.CANCEL_OPEN_DAILOG);
    }else{
      this.router.navigate([APP_ROUTES.GST_LIST]);
    }
  }

  getGstTypes(){
    this.service.get(Api.GST_TYPES).subscribe(res => { 
			 this.gstTypes=res;
		});
  }

  private getGstById(){
    this.service.get(Api.GST+'/'+this.id.value).subscribe(res => {
      if(res){
        this.logger.info('Gst Form By Id Res',res);
        this.gstForm.patchValue(res);
      }
    });
  }

  private getAllPermissions(){
    let permissionCodes=[PermissionKey.GST_ADD_PERMISSION,PermissionKey.GST_EDIT_PERMISSION];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.GST);
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.GST_EDIT_PERMISSION})?.show?true:false;
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.GST_ADD_PERMISSION})?.show?true:false;
  }

  get code(){return this.gstForm.get('code');}
  get name(){return this.gstForm.get('name');}
  get type(){return this.gstForm.get('type');}
  get id(){return this.gstForm.get('id');}
}